import { Injectable } from "@angular/core";
import { PreloadingStrategy, Route } from "@angular/router";
import { Observable, of } from "rxjs";

/**
 * TODO
 * attualemente il preloading è disabilitato per tutte le route
 * valutare se nè necessario implementare una strategia più "intelligente"
 */

@Injectable()
export class AppCustomPreloadingStrategy implements PreloadingStrategy {
  preload(route: Route, fn: () => Observable<any>): Observable<any> {
    return of(null);
  }
}
